export const PAGENATION_SIZE = {
  DASHBOARD: {
    MEMBERS: 4,
    INVITATIONS: 5,
    SIDEBAR: 10,
    MYDASHBOARD: 5,
    CARDS: 5
  }
} as const;
